import { getDetailedErrorMessage } from "../../../utils";
export class OptimizationTemplateFetchFailed extends Error {
    /**
     * @param apiError: the error received from the API.
     * @param fallbackMessage: the message to use for the error, if the API error does not contain anything relevant.
     */
    constructor(apiError, fallbackMessage = "Failed to fetch optimization templates. Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, OptimizationTemplateFetchFailed);
        }
        this.name = "OptimizationTemplateFetchFailed";
        this.message = `Failed to fetch optimization templates. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
export class OptimizationTemplateSaveFailed extends Error {
    /**
     * @param apiError: the error received from the API.
     * @param fallbackMessage: the message to use for the error, if the API error does not contain anything relevant.
     */
    constructor(apiError, fallbackMessage = "Failed to save optimization template. Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, OptimizationTemplateSaveFailed);
        }
        this.name = "OptimizationTemplateSaveFailed";
        this.message = `${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
//# sourceMappingURL=errors.js.map